import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  error: '',
  success: '',
  user: {},
};

const UserSlice = createSlice({
  name: 'User',
  initialState,
  reducers: {
    userSuccess(state, action) {
      state.success = action.payload.status;
      state.user = action.payload.data; // Check this line
    },

    userError(state, action) {
      state.error = action.payload;
    },
    // editUserChange(state) {
    //   state = { ...state };
    // },
    // resetUserFlagChange(state: any) {
    //   state.success = null;
    // },
  },
});

export const { userSuccess, userError } = UserSlice.actions;

export default UserSlice.reducer;
